export default "__VITE_ASSET__BlEASPnw__"